import React, { useState, useEffect, useCallback, memo } from 'react';
import { Box, IconButton, Icon } from '@material-ui/core';
import Swiper from 'react-id-swiper';
import moment from 'moment';

import { useSchedule } from '../context';
import Slot from '../Slot';
import useStyles from './styles';
import Loading from './Loading';

const RowHeaders = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const {
    isInitialSlide,
    scheduleAppointments,
    headerSwiper,
    setHeaderSwiper,
    visibleColumns,
  } = useSchedule();

  useEffect(() => {
    setLoading(!scheduleAppointments.length);
  }, [scheduleAppointments]);

  const getDateFormated = useCallback(date => {
    return moment(date).utc().startOf('d').format('DD/MM/YYYY');
  }, []);

  const goNext = useCallback(() => {
    if (headerSwiper !== null) {
      headerSwiper.slideNext();
    }
  }, [headerSwiper]);

  const goPrev = useCallback(() => {
    if (headerSwiper !== null) {
      headerSwiper.slidePrev();
    }
  }, [headerSwiper]);

  return loading ? (
    <Loading columns={visibleColumns} />
  ) : (
    <Box className={classes.container}>
      <Box className="schedule-slot-controls-container">
        <Box className="schedule-slot-controls-content">
          <IconButton
            onClick={goPrev}
            disabled={isInitialSlide}
            color="primary"
          >
            <Icon>chevron_left</Icon>
          </IconButton>
          <IconButton onClick={goNext} color="primary">
            <Icon>chevron_right</Icon>
          </IconButton>
        </Box>
      </Box>
      <Box className="swiper-header-wrapper">
        {!!visibleColumns && (
          <Swiper
            getSwiper={setHeaderSwiper}
            containerClass="swiper-header-container"
            shouldSwiperUpdate
          >
            {scheduleAppointments.map((day, index) => (
              <Box
                key={moment(day.date).format(`DD/MM/YYYY-${index}`)}
                className="swiper-header-column-container"
              >
                <Box className="swiper-header-column-content">
                  <Slot label>{getDateFormated(day.date)}</Slot>
                </Box>
              </Box>
            ))}
          </Swiper>
        )}
      </Box>
    </Box>
  );
};

export default memo(RowHeaders);
